export class RadioAdvertising {
  public carouselItems: Array<{ title: string; categories: Array<string>, active?: boolean }> = [
    {
      title: 'Traditional Radio Buying',
      categories: ['30 Second generic spot placement'],
      active: true
    }, {
      title: 'Non-Traditional radioBuying',
      categories: ['Anything that’s not a 30 second generic spot.', 'This could be sponsorships, branded content, endorsed content, competitions and more.']
    }, {
      title: 'Integrating with digital elements',
      categories: []
    }
  ];
}